export const PUBLISH_MODAL_COPY = {
  approvalRequired: {
    title: 'Send for review',
    submitButton: 'Send for review',
    submittingButton: 'Submitting...',
    body: "You're about to submit this quote for review. Once approved, the quote will be automatically published.",
    messageLabel: 'Message (optional)',
    messagePlaceholder: 'Add message for reviewer'
  },
  /**
   * Each body below has a second version, `bodyAuthRequired`, for an account
   * that makes quote recipients sign in. There the link on its own gets you
   * nowhere, so promising anyone holding it can read the quote would be wrong.
   */
  publishQuote: {
    title: 'Publish quote',
    submittingButton: 'Publishing...',
    body: "You're about to publish this quote. This quote will be visible to anyone with the link.",
    bodyAuthRequired:
      "You're about to publish this quote. This quote is only visible to those with access."
  },
  publishChanges: {
    title: 'Publish changes',
    body: "You're about to publish changes to this quote. All changes will be visible to anyone with the link and cannot be undone.",
    bodyAuthRequired:
      "You're about to publish changes to this quote. All changes are only visible to those with access and cannot be undone."
  },
  republishQuote: {
    title: 'Republish quote'
  },
  autoRejected: {
    title: "This quote can't be published",
    closeButton: 'Close',
    body: 'This quote does not pass the approval workflow rules, and cannot be published'
  },
  /**
   * Each button gains "and share" once at least one recipient is ticked, since
   * publishing on its own sends nothing.
   */
  recipients: {
    heading: 'Share by email (optional)',
    messageLabel: 'Message (optional)',
    messagePlaceholder: 'Add message',
    publishButton: 'Publish',
    publishAndShareButton: 'Publish and share',
    publishChangesButton: 'Publish changes',
    publishChangesAndShareButton: 'Publish changes and share',
    republishButton: 'Republish quote',
    republishAndShareButton: 'Republish quote and share'
  }
} as const

/**
 * Which sentence a publish modal opened with, named so a test can assert the
 * case rather than matching the copy word for word. Each modal puts one of
 * these on its body, so the modal's own test id still says which modal it is.
 */
export const PUBLISH_BODY_TEST_IDS = {
  anyoneWithTheLink: 'quote.publishModal.body.anyoneWithTheLink',
  authRequired: 'quote.publishModal.body.authRequired',
  approvalRequired: 'quote.publishModal.body.approvalRequired',
  expiryReset: 'quote.publishModal.body.expiryReset'
} as const

export const MODAL_BASE_PROPS = {
  variant: 'dialog',
  disableSubmitOnEnter: true,
  dialogPosition: 'top',
  isOpen: true
} as const
